import React from "react";
import "./style.css";
import { lifeAtBitsclanData } from "../../data/lifeAtBitsclanData";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";

const PerkAndBenifit = () => {
  const { t } = useTranslation("lifeAtBitsclan");

  // Get translated projects array
  const perksAndBenefit = t("perksAndBenefit", { returnObjects: true });
  return (
    <>
      <div className="perks-and-benifits">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="banner-heading text-center">
                {perksAndBenefit.heading}{" "}
                <span>{perksAndBenefit.coloredHeading}</span>
              </h2>
              <p className="common-text text-center text-white">
                {perksAndBenefit.paragraph}
              </p>
            </div>
          </div>

          <div className="row perk-icon-leftside mt-5">
            {perksAndBenefit.benefits.map((item) => {
              return (
                <div className="col-xl-3 col-lg-3 col-md-6 border-cards p-0">
                  <div className="perk-card">
                    <div className="perk-icon">
                      <img src={`/images/${item.icon}`} alt={`${item.icon}`} />
                    </div>
                    <h3>{item.title}</h3>
                    <p className="common-text">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="w-100 d-flex justify-content-center mt-5 ">
                {/* <a
                  id="industry_link_click"
                  href="http://theremotepad.com/join-a-team"
                  target="_blank"
                >
                  {perksAndBenefit?.joinOurTeamButton}{" "}
                  <i
                    className={`fa-solid ${
                      document.dir === "rtl"
                        ? "fa-arrow-left"
                        : "fa-arrow-right"
                    }`}
                  ></i>
                </a> */}
                {/* <Button
                  text={perksAndBenefit?.joinOurTeamButton}
                  link={"http://theremotepad.com/join-a-team"}
                  newTab
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PerkAndBenifit;
